export default {
    ADD_UNIT(state, unit) {
      state.units.unshift(unit);
      state.totalDataRow++;
    },
    SET_UNIT(state, res) {
      state.units = res.items
      state.totalDataRow = res.totalCount;
    },
    UPDATE_UNIT(state, unit) {
      const unitIndex = state.units.findIndex((p) => p.id == unit.id)
      Object.assign(state.units[unitIndex], unit)
    },
    REMOVE_UNIT(state, unitId) {
      const unitIndex = state.units.findIndex((p) => p.id == unitId)
      state.units.splice(unitIndex, 1)
    },
  }
  